var React = require('react');

function LliconDashboard (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.75 0.75)"},[React.createElement("circle",{"strokeLinecap":"round","strokeLinejoin":"round","fill":"none","stroke":"#2f4758","strokeWidth":"1.5px","cx":"3.75","cy":"3.75","r":"3.75","transform":"translate(5.25)","key":0}),React.createElement("path",{"fill":"none","stroke":"#2f4758","strokeWidth":"1.5px","d":"M18.9,18.5V17a7.522,7.522,0,0,0-7.5-7.5h-3A7.522,7.522,0,0,0,.9,17v1.5","transform":"translate(-0.9 1.25)","key":1})]));
}

LliconDashboard.defaultProps = {"width":"19.5","height":"20.5","viewBox":"0 0 19.5 20.5"};

module.exports = LliconDashboard;

LliconDashboard.default = LliconDashboard;
